import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ListalicenciasService } from 'src/app/services/solicitante/listalicencias.service';
import { Licencia } from '../../models/licencia';
import { NgZone } from '@angular/core';


@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css']
})
export class PrincipalComponent implements OnInit {
  title = 'frontend';
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  showcompraLicencia = false;


  licencia: Licencia[];
  precioDia = 10;
  precioSemana = 0;
  precioMes = 0;
  precioAno = 0;
  precioExcursion = 0;

  constructor(
    private listalicenciasService: ListalicenciasService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private ngZone: NgZone
    ) { }

  ngOnInit() {

    localStorage.setItem('pagina', 'publico');
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });



    this.listalicenciasService.getLicencias()
    .subscribe(
      licen => {
         this.licencia = licen;
         this.precioDia = this.licencia[0].preciopublico;
         this.precioSemana = this.licencia[1].preciopublico;
         this.precioMes = this.licencia[2].preciopublico;
         this.precioAno = this.licencia[3].preciopublico;
         this.precioExcursion = this.licencia[4].preciopublico;


       },

      );

  }




muestraprocesolicencia(){
  this.ngZone.run(() => this.router.navigate(['obtenerlicencia']));

  }

}
